// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--a9dww","size_default":"size_default--Kr8QT","size_wysiwyg":"size_wysiwyg--o47HB","size_maxcontent":"size_maxcontent--e9zmT"};